import { useSearchParams } from "react-router-dom";
import Numbers from "./Numbers";
import OptIns from "./OptIns";

// Phone infrastructure in one place: the numbers themselves + the TCPA opt-in audit
// trail for texting on them (opt-ins used to be its own main nav tab).
const TABS = [
  ["numbers", "Numbers"],
  ["optins", "Opt-Ins & Opt-Outs"],
];

export default function NumbersHub() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "numbers";
  return (
    <div className="space-y-6">
      <div className="inline-flex rounded-full bg-sand-100 border border-sand-200 p-1" data-testid="numbers-hub-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`numbers-tab-${k}`} onClick={() => setSp({ tab: k })}
            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${tab === k ? "bg-ink text-white shadow-sm" : "text-ink/60 hover:text-ink"}`}>
            {l}
          </button>
        ))}
      </div>
      {tab === "optins" ? <OptIns /> : <Numbers />}
    </div>
  );
}
